import { render, staticRenderFns } from "./InteractiveConsoleDraggable.vue?vue&type=template&id=60d5cf38&scoped=true"
import script from "./InteractiveConsoleDraggable.vue?vue&type=script&lang=ts"
export * from "./InteractiveConsoleDraggable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5cf38",
  null
  
)

export default component.exports